import React from "react";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import {
  QuestionMarkCircleIcon,
  PlusCircleIcon,
  Square3Stack3DIcon,
} from "@heroicons/react/24/solid";
 
export default function EquityFundTabs() {
  const data = [
    {
      label: "Who Should Invest?",
      value: "Invest",
      icon: QuestionMarkCircleIcon,
      desc: `
      It is a suitable investment option for investors looking to put money in the stock market but lack the professional capacity to select and manage their equity portfolio.
      
      Equity fund is Suitable to investors with a long term investment horizon of 5 years or more`,
    },
    {
      label: "Benefits",
      value: "Benefits",
      icon: PlusCircleIcon,
      desc: `Allows diversification - investing in different stock sectors under one pool also
      professional management for fixed low fees`,
    },
    {
      label: "Features",
      value: "Features",
      icon:  Square3Stack3DIcon,
      desc: `Initial fee 2% of invested funds and
      Management Fee 2.5 % per annum`,
    },
  ];
  return (
    <Tabs value="Invest">
      <TabsHeader>
        {data.map(({ label, value, icon }) => (
          <Tab key={value} value={value}>
            <div className="flex items-center gap-2">
              {React.createElement(icon, { className: "w-5 h-5" })}
              {label}
            </div>
          </Tab>
        ))}
      </TabsHeader>
      <TabsBody>
        {data.map(({ value, desc }) => (
          <TabPanel key={value} value={value}>
            {desc}
          </TabPanel>
        ))}
      </TabsBody>
    </Tabs>
  );
}